var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdiFaceNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:face-sad"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2H22V22H2V2ZM8 15H16V17H8V15ZM7 9.5C7 8.7 7.7 8 8.5 8C9.3 8 10 8.7 10 9.5C10 10.3 9.3 11 8.5 11C7.7 11 7 10.3 7 9.5ZM15.5 11C14.7 11 14 10.3 14 9.5C14 8.7 14.7 8 15.5 8C16.3 8 17 8.7 17 9.5C17 10.3 16.3 11 15.5 11Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiFaceNormal);
export default __webpack_public_path__ + "static/media/mdi_face-normal.430386cddebc72339d1bf82bbf0d0bd0.svg";
export { ForwardRef as ReactComponent };